import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Document } from '../../../models/document.model';
import { CustomFunctions } from '../../../../shared/helpers/custom-functions.helper';

@Component({
  standalone: false,
  selector: 'app-document-additional-info',
  templateUrl: './document-additional-info.component.html',
  styleUrls: ['../modal.component.scss'],
})
export class DocumentAdditionalInfoComponent {
  @Input() document: Document;
  isHistoryLogOpen: boolean;

  @Output() readonly responseChanged = new EventEmitter();

  constructor(public customFunctions: CustomFunctions) {}

  toggleHistoryLog(): void {
    this.isHistoryLogOpen = !this.isHistoryLogOpen;
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}
